<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">
      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['title', { rules: [{ required: true, message: '请输入广告名称' }] }]" />
      </a-form-item>

      <a-form-item label="所属广告位" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-spin :spinning="adPlaceLoading">
          <a-select
            allow-clear
            optionFilterProp="children"
            v-decorator="[
              'place',
              {
                rules: [{ required: true, message: '请选择所属分类' }]
              }
            ]"
          >
            <a-select-option v-for="item in adPlaceList" :key="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-spin>
      </a-form-item>
      <a-form-item label="上传图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <img-upload
          name="thum"
          v-decorator="['image', { rules: [{ required: true, message: '请上传图片' }] }]"
        />
      </a-form-item>
      <a-form-item label="打开方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="['open_type', { rules: [{ required: true, message: '请选择所属分类' }] }]">
          <a-select-option :key="1">当前页打开</a-select-option>
          <a-select-option :key="2">跳转打开</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="链接地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="link"
          v-decorator="['link', { rules: [{ type: 'url', message: '请输入正确的链接' }] }]"
        />
      </a-form-item>

      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
        <a-input
          name="order"
          v-decorator="[
            'order',
            {
              initialValue: '0'
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-date-picker
          showTime
          :disabled-date="disabledStartDate"
          placeholder="请选择开始时间"
          style="width: 100%"
          format="YYYY-MM-DD HH:mm:ss"
          name="start_at"
          v-decorator="['start_at']"
        />
      </a-form-item>
      <a-form-item label="过期时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-date-picker
          showTime
          :disabled-date="disabledExpireDate"
          placeholder="请选择过期时间"
          style="width: 100%"
          name="expire_at"
          format="YYYY-MM-DD HH:mm:ss"
          v-decorator="['expire_at']"
        />
      </a-form-item>
      <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认展示">
        <a-switch
          checked-children="展示"
          un-checked-children="隐藏"
          name="state"
          v-decorator="[
            'state',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { ImgUpload } from '@/components'
import { select } from '@/mixins'
import { requestGet, requestPost, requestPut } from '@/api/api'

const fields = ['title', 'place', 'image', 'order', 'expire_at', 'state', 'start_at', 'link', 'open_type']
const apiList = {
    selectList: '/ads/places/select'
}
export default {
    name: 'ModelForm',
    mixins: [select],
    props: {
        aid: {
            type: Number,
            default: null
        }
    },
    components: {
        ImgUpload
    },
    data () {
        return {
            loading: false, // 图片上传加载
            spinning: false, // 页面加载
            adPlaceLoading: true, // 广告位加载
            startValue: null,
            endValue: null,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            status: true,
            adPlaceList: [],
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        this.getSelectLists({
            url: apiList.selectList,
            type: 'adPlaceList',
            load: 'adPlaceLoading'
        }) // 获取广告位列表
        if (this.aid) {
            this.spinning = true
            this.getAd(this.aid) // 获取广告信息
        }
    },
    methods: {
        /**
         * 禁止开始日期
         * 开始日期 > 结束日期
         * @startValue
         */
        disabledStartDate (startValue) {
            const endValue = this.form.getFieldValue('expire_at')
            if (!endValue) {
                return false
            } else {
                return startValue.valueOf() > this.moment(endValue).valueOf()
            }
        },
        /**
         * 禁止过期日期
         * 开始日期 > 结束日期
         * @endValue
         */
        disabledExpireDate (endValue) {
            const startValue = this.form.getFieldValue('start_at')
            if (!startValue) {
                return false
            } else {
                return this.moment(startValue).valueOf() >= endValue.valueOf()
            }
        },
        /**
         * 获取编辑广告信息
         * id
         * @param
         */
        getAd (id) {
            requestGet('/ads/' + id)
                .then(res => {
                    this.spinning = false
                    res.result.start_at = res.result.start_at
                        ? this.moment(res.result.start_at * 1000).format('YYYY-MM-DD HH:mm:ss')
                        : null
                    res.result.expire_at = res.result.expire_at
                        ? this.moment(res.result.expire_at * 1000).format('YYYY-MM-DD HH:mm:ss')
                        : null
                    res.result.state = res.result.state === 1
                    this.form.setFieldsValue(pick(res.result, fields))
                })
                .catch(err => console.log(err))
        },
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
                        values.expire_at = this.moment(values.expire_at).format('YYYY-MM-DD HH:mm:ss')
                        if (this.aid) {
                            // 有aid编辑，没aid创建
                            requestPut('/ads/' + this.aid, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: res.msg
                                    })
                                    resolve(true) // 关闭弹出层
                                })
                        } else {
                            requestPost('/ads/create', values)
                                .then(res => {
                                    this.$notification.success({
                                        message: res.msg
                                    })
                                    resolve(true) // 关闭弹出层
                                })
                        }
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>
